import { Box, Container, Heading, Text, VStack, Grid } from "@chakra-ui/react";
import { Helmet } from 'react-helmet-async';
import ServiceDetailsHeader from "../../components/Common/ImageHeader";
import ServiceCard from "../../components/Common/ServiceCard";
// import ServicesGrid from "../../components/Common/ServicesGrid";
import ExploreSection from "../../components/ProductDetails/ExploreSection";

const DevOpsServicesPage = () => {
  // DevOps Tools Data
  // const devOpsToolsData = [
  //   {
  //     id: 1,
  //     icon: "/svg/dev_7.svg",
  //     title: "CI/CD: Jenkins, GitLab CI, Azure DevOps, GitHub Actions",
  //     description: "",
  //     isTopRow: true,
  //     isLeftmost: true,
  //   },
  //   {
  //     id: 2,
  //     icon: "/svg/dev_8.svg",
  //     title: "IaC: Terraform, AWS CloudFormation, Ansible",
  //     description: "",
  //     isTopRow: true,
  //     isRightmost: false,
  //   },
  //   {
  //     id: 3,
  //     icon: "/svg/dev_9.svg",
  //     title: "Containers & Orchestration: Docker, Kubernetes",
  //     description: "",
  //     isTopRow: true,
  //     isRightmost: true,
  //   },
  //   {
  //     id: 4,
  //     icon: "/svg/dev_10.svg",
  //     title: "Monitoring: Prometheus, Grafana, ELK Stack",
  //     description: "",
  //     isTopRow: false,
  //     isBottomRow: true,
  //     isLeftmost: true,
  //   },
  //   {
  //     id: 5,
  //     icon: "/svg/dev_11.svg",
  //     title: "Collaboration: Jira, Confluence, Teams, Slack",
  //     description: "",
  //     isTopRow: false,
  //     isBottomRow: true,
  //     isRightmost: false,
  //   },
  //   {
  //     id: 6,
  //     icon: "/svg/dev_12.svg",
  //     title: "Security: SonarQube, Checkmarx, OWASP ZAP",
  //     description: "",
  //     isTopRow: false,
  //     isBottomRow: true,
  //     isRightmost: true,
  //   },
  // ];

  // Why Business Automation Limited for DevOps? Data
  const whyChooseUsData = [
    {
      id: 1,
      icon: "/svg/dev_1.svg",
      title: "25+ Years of Experience in mission-critical digital platforms",
      description: "",
    },
    {
      id: 2,
      icon: "/svg/dev_2.svg",
      title: "Proven in e-Government, licensing, land management, and OSS",
      description: "",
    },
    {
      id: 3,
      icon: "/svg/dev_3.svg",
      title:
        "Readiness for donor-funded systems and inter-agency collaboration",
      description: "",
    },
    {
      id: 4,
      icon: "/svg/dev_4.svg",
      title:
        "Aligned with Smart Bangladesh, Digital Governance, and global security protocols",
      description: "",
    },
    {
      id: 5,
      icon: "/svg/dev_5.svg",
      title:
        "DevOps-as-a-Service (DaaS) model available for long-term partnerships",
      description: "",
    },
    {
      id: 6,
      icon: "/svg/dev_6.svg",
      title: "Local experts",
      description: "",
    },
  ];
  const businessImpact = [
    {
      id: 1,
      icon: "/svg/dev_1.svg",
      title: "40% faster deployment cycles",
      description: "",
    },
    {
      id: 2,
      icon: "/svg/dev_2.svg",
      title: "99.9% uptime assurance",
      description: "",
    },
    {
      id: 3,
      icon: "/svg/dev_3.svg",
      title: "Seamless scalability for 8,000+ concurrent users",
      description: "",
    },
    {
      id: 3,
      icon: "/svg/dev_3.svg",
      title: "Trusted by national digital platforms",
      description: "",
    },
  ];

  return (
    <>
      <Helmet>
        {/* Basic Meta Tags */}
        <title>DevOps Services | CI/CD, IaC, Kubernetes, DevSecOps & Automation in Bangladesh</title>
        <meta 
          name="description" 
          content="Accelerate delivery with Business Automation's DevOps Services—CI/CD pipelines, Kubernetes, cloud automation, monitoring, and security for eGovernment and enterprise solutions in Bangladesh." 
        />
        <meta 
          name="keywords" 
          content="DevOps services Bangladesh, CI/CD automation Bangladesh, Infrastructure as Code Bangladesh, Kubernetes deployment Bangladesh, DevSecOps Bangladesh, Docker and container services Bangladesh, real-time monitoring Bangladesh, donor-compliant DevOps services, agile software delivery Bangladesh, government DevOps partner, AI-based DevOps analytics" 
        />
        <link rel="canonical" href="https://www.ba-systems.com/services/devops-services" />
        <meta name="robots" content="index, follow" />

        {/* Open Graph / Facebook */}
        <meta property="og:url" content="https://ba-systems.com/services/devops-services" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="DevOps Services | CI/CD, IaC, Kubernetes, DevSecOps & Automation in Bangladesh" />
        <meta property="og:description" content="Accelerate delivery with Business Automation's DevOps Services—CI/CD pipelines, Kubernetes, cloud automation, monitoring, and security for eGovernment and enterprise solutions in Bangladesh." />
        <meta property="og:image" content="https://opengraph.b-cdn.net/production/images/e1930f8a-3aa2-4fe1-b6ea-0ad5030ebc97.png?token=vTkCXbq7qBnee_uxOFTj3-OKo7vP2KVzX66L6BYKzho&height=596&width=1200&expires=33297038875" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta property="twitter:domain" content="ba-systems.com" />
        <meta property="twitter:url" content="https://ba-systems.com/services/devops-services" />
        <meta name="twitter:title" content="DevOps Services | CI/CD, IaC, Kubernetes, DevSecOps & Automation in Bangladesh" />
        <meta name="twitter:description" content="Accelerate delivery with Business Automation's DevOps Services—CI/CD pipelines, Kubernetes, cloud automation, monitoring, and security for eGovernment and enterprise solutions in Bangladesh." />
        <meta name="twitter:image" content="https://opengraph.b-cdn.net/production/images/e1930f8a-3aa2-4fe1-b6ea-0ad5030ebc97.png?token=vTkCXbq7qBnee_uxOFTj3-OKo7vP2KVzX66L6BYKzho&height=596&width=1200&expires=33297038875" />
      </Helmet>
      
      <ServiceDetailsHeader
        title="DevOps Services"
        subtitle="Streamlined Development & Operations Solutions"
        backgroundImage="/png/bg_dev.png"
        breadcrumbItems={[
          { label: "Home", href: "/" },
          { label: "Services", href: "/our-services" },
          { label: "DevOps Services", href: "#", isCurrentPage: true },
        ]}
      />
      <Box
        w="full"
        backgroundImage="url('/png/background.png')"
        backgroundSize="cover"
        backgroundPosition="center"
        backgroundRepeat="no-repeat"
      >
        <Box py={{ base: "30px", md: "40px" }}>
          <Container maxW="7xl">
            <VStack spacing={8} align="start">
              {/* Header Section */}
              <VStack spacing={4} align="start" w="full">
                <Text
                  fontSize={{ base: "md", md: "lg" }}
                  color="gray.600"
                  lineHeight="1.2"
                  textAlign="justify"
                >
                  At Business Automation Limited, we offer cutting-edge DevOps
                  services that unify software development, deployment, and
                  operations into a seamless, agile lifecycle. Our approach
                  enables faster releases, reliable performance, and continuous
                  innovation—empowering government, enterprise, and donor-backed
                  projects to deliver more with less friction
                </Text>
                <Text
                  fontSize={{ base: "md", md: "lg" }}
                  color="gray.600"
                  lineHeight="1.2"
                  textAlign="justify"
                >
                  Built on industry-leading tools and intelligent automation,
                  our DevOps services accelerate time-to-value, minimize
                  operational risks, and promote collaborative co-creation of
                  digital platforms aligned with national strategies like Smart
                  Bangladesh and Vision 2041.
                </Text>
              </VStack>
              <Heading
                fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
                fontWeight="bold"
                color="gray.800"
              >
                What{" "}
                <Text as="span" color="#000B8C">
                  We Offer
                </Text>
              </Heading>
              <Box w="full">
                <img
                  src="/png/dev_info.png"
                  alt="Application Migration Services"
                  style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "12px",
                    objectFit: "cover",
                  }}
                  loading="lazy"
                />
              </Box>
              <Box w="full" py={8}></Box>
              <Heading
                fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
                fontWeight="bold"
                color="gray.800"
              >
                Our DevOps {" "}
                <Text as="span" color="#000B8C">
                  Toolchain
                </Text>
                ?
              </Heading>
              <Box w="full">
                <img
                  src="/png/dev_chain.png"
                  alt="Application Migration Services"
                  style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "12px",
                    objectFit: "cover",
                  }}
                  loading="lazy"
                />
              </Box>

              <Box w="full" py={16}>
                <VStack spacing={0} align="start" w="full">
                  <VStack spacing={4} pb={4} align="start" w="full">
                    <Heading
                      fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
                      fontWeight="bold"
                      color="gray.800"
                    >
                      Why Business Automation Limited for{" "}
                      <Text as="span" color="#000B8C">
                        DevOps
                      </Text>
                      ?
                    </Heading>
                  </VStack>
                  {/* <Text fontSize={{ base: "md", md: "lg" }} pb={6} color="gray.600">
                    Your records are integrated into:
                  </Text> */}

                  {/* Benefits Grid - 2 rows, 3 columns */}
                  <Grid
                    templateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }}
                    gap={6}
                    w="full"
                    maxW="7xl"
                    mx="auto"
                  >
                    {whyChooseUsData.map((service) => (
                      <ServiceCard key={service.id} service={service} />
                    ))}
                  </Grid>
                </VStack>
              </Box>
              <Box w="full" py={0}>
                <VStack spacing={8} align="start" w="full">
                  <VStack spacing={4} align="start" w="full">
                    <Heading
                      fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
                      fontWeight="bold"
                      color="gray.800"
                    >
                      Business Impact of Our DevOps Services{" "}
                      <Text as="span" color="#000B8C"></Text>
                    </Heading>
                  </VStack>

                  {/* Benefits Grid - 2 rows, 4 columns */}
                  <Grid
                    templateColumns={{ base: "1fr", md: "repeat(4, 1fr)" }}
                    gap={6}
                    w="full"
                    maxW="7xl"
                    mx="auto"
                  >
                    {businessImpact.map((impact) => (
                      <ServiceCard key={impact.id} service={impact} />
                    ))}
                  </Grid>
                </VStack>
              </Box>

              {/* DevOps Tools Section */}
              {/* <ServicesGrid
                title="DevOps tools we work with"
                services={devOpsToolsData}
              /> */}
              
            </VStack>
          </Container>
        </Box>
        <ExploreSection />
      </Box>
    </>
  );
};

export default DevOpsServicesPage;
